import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * P Image Badge Setting Handler
 */
export class ShBadgeGradient extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const allRgba: any = [];
    let firstBackgound = 'none';
    let secondBackgound = 'none';
    if (allRgba && allRgba.length > 0) {
      firstBackgound = allRgba[1] ? HELPER.rgb2hex(allRgba[1]) : 'none';
      secondBackgound = allRgba[2] ? HELPER.rgb2hex(allRgba[2]) : 'none';
      // fill firstBackgound value
      options.$activePanel
        .find('#firstBackgound')
        .attr('value', firstBackgound)
        .val(firstBackgound)
        .trigger('value-change');
      // fill secondBackgound value
      options.$activePanel
        .find('#secondBackgound')
        .attr('value', secondBackgound)
        .val(secondBackgound)
        .trigger('value-change');
    }
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;

    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      const $self = this.getAtomTarget('write', this);
      const firstBackgound = options.$activePanel.find('#firstBackgound').val();
      const secondBackgound = options.$activePanel.find('#secondBackgound').val();
      let singleBg: any = '';
      let deOptions: any = [];
      if (firstBackgound != 'none' && secondBackgound == 'none') {
        singleBg = firstBackgound;
        deOptions = [
          {
            key: 'background',
            value: singleBg,
          },
        ];
      } else if (firstBackgound == 'none' && secondBackgound != 'none') {
        singleBg = secondBackgound;
        deOptions = [
          {
            key: 'background',
            value: singleBg,
          },
        ];
      } else if (firstBackgound != 'none' && secondBackgound != 'none') {
        deOptions = [
          {
            key: 'background',
            value: singleBg,
          },
          {
            key: 'background',
            value: `-webkit-linear-gradient(to right, ${firstBackgound}, ${secondBackgound})`,
          },
          {
            key: 'background',
            value: `linear-gradient(to right, ${firstBackgound}, ${secondBackgound})`,
          },
        ];
      }
      style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, '.gf_badge-text-wrap');
    }
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
